import { useState } from "react";
import {
  baseRouteMaker,
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useSuperAdminCustomerDetailsTabMenuUtils = () => {
  const [menuGroup, setMenuGroup] = useState(() => {
    const tempMenuGroup = [];

    /* menuItemDetails */
    const menuItemDetails = {
      id: "super-admin-customers",
      title: t("Modules.Provider.details"),
      url: baseRouteMakerForSuperAdmin(routes.CUSTOMER_INFO_DETAILS_DETAILS),
    };
    tempMenuGroup.push(menuItemDetails);
    /* menuItemDetails */

    /* menuItemAppointments */
    const menuItemAppointments = {
      id: "super-admin-customer-appointments-details",
      title: t("Modules.Provider.appointments"),
      url: baseRouteMakerForSuperAdmin(routes.CUSTOMER_INFO_DETAILS_APPOINTMENTS),
    };
    tempMenuGroup.push(menuItemAppointments);
    /* menuItemAppointments */

    return tempMenuGroup;
  });

  return menuGroup;
};
